// THUMBNAILS

// ---- EXTERIOR ----
// Colors
import progressiveRedMetallic from "../assets/thumbnails/colors/Progressive_Red_Metallic_opt.jpg";
import kemoraGrayMetallic from "../assets/thumbnails/colors/Kemora_Gray_Metallic_opt.jpg";
import ascariBlueMetallic from "../assets/thumbnails/colors/Ascari_Blue_Metallic_opt.jpg";
import mythBlackMetallic from "../assets/thumbnails/colors/Myth_Black_Metallic_opt.jpg";
import pythonYellowMetallic from "../assets/thumbnails/colors/Python_Yellow_Metallic_opt.jpg";
import daytonaGrayPearlescent from "../assets/thumbnails/colors/Daytona_Gray_Pearlescent_opt.jpg";
import arkonaWhite from "../assets/thumbnails/colors/Arkona_White_opt.jpg";
import kyalamiGreen from "../assets/thumbnails/colors/Kyalami_Green_opt.jpg";
import individualPaint from "../assets/thumbnails/colors/Individual_Paint_opt.jpg";

//Materials
import carbonFiber from "../assets/thumbnails/materials/carbon_fiber.png";
import forgedCarbon from "../assets/thumbnails/materials/forged_carbon.png";

// Wheels Types
import wheelTypeF50Style from "../assets/thumbnails/wheels/type/wheel_F50_style.png";
import wheelTypeGT3Style from "../assets/thumbnails/wheels/type/wheel_GT3_style.png";
import wheelTypeS3Style from "../assets/thumbnails/wheels/type/wheel_S3_style.png";
import wheelTypeRotiformKPR from "../assets/thumbnails/wheels/type/wheel_rotiform_kpr.png";
import wheelTypeRotiformNGO from "../assets/thumbnails/wheels/type/wheel_rotiform_ngo.png";
import wheelTypeRotiformNGO2 from "../assets/thumbnails/wheels/type/wheel_rotiform_ngo2.png";

// Wheels Colors
import wheelColorHyperSilver from "../assets/thumbnails/wheels/colors/wheel_hyper_silver.png";
import wheelColorWhite from "../assets/thumbnails/wheels/colors/wheel_white.png";
import wheelColorWhiteGold from "../assets/thumbnails/wheels/colors/wheel_white_gold.png";
import wheelColorBlack from "../assets/thumbnails/wheels/colors/wheel_black.png";
import wheelColorAnthracite from "../assets/thumbnails/wheels/colors/wheel_anthracite.png";
import wheelColorBronze from "../assets/thumbnails/wheels/colors/wheel_bronze.png";

//Tires
import tireToyoProxes from "../assets/thumbnails/tires/tire_toyo_proxes_r888r.png";
import tireMichelinPS4S from "../assets/thumbnails/tires/tire_michelin_ps4s.png";

//Spoiler
import withSpoiler from "../assets/thumbnails/spoiler/spoiler_on.png";
import withoutSpoiler from "../assets/thumbnails/spoiler/spoiler_off.png";

// Exhaust Type
import exhaust1pipe from "../assets/thumbnails/exhaust/type/exhaust_1_pipe.png";
import exhaust2pipes from "../assets/thumbnails/exhaust/type/exhaust_2_pipes.png";

//Exhaust Material
import stainlessSteelMaterial from "../assets/thumbnails/exhaust/material/stainless_steel1.png";
import titaniumMaterial from "../assets/thumbnails/exhaust/material/titanium1.png";
import inconelMaterial from "../assets/thumbnails/exhaust/material/inconel1.png";
import ceramicCoatingMaterial from "../assets/thumbnails/exhaust/material/ceramic_coating1.png";

// ---- INTERIOR ----
//Interior Leather
import leatherBlackBlack from "../assets/thumbnails/interior/leather/leather_black_black.png";
import leatherBlackBrown from "../assets/thumbnails/interior/leather/leather_black_brown.png";
import leatherBlackRed from "../assets/thumbnails/interior/leather/leather_black_red.png";
import leatherBlackTangerine from "../assets/thumbnails/interior/leather/leather_black_tangerine.png";
import leatherNavyBlueNavyBlue from "../assets/thumbnails/interior/leather/leather_navyBlue_navyBlue.png";
import leatherNavyBlueBlack from "../assets/thumbnails/interior/leather/leather_navyBlue_black.png";

//Interior Alcantara
import alcantaraBlackBlack from "../assets/thumbnails/interior/alcantara/alcantara_black_black.png";
import alcantaraBlackBrown from "../assets/thumbnails/interior/alcantara/alcantara_black_brown.png";
import alcantaraBlackRed from "../assets/thumbnails/interior/alcantara/alcantara_black_red.png";
import alcantaraBlackTangerine from "../assets/thumbnails/interior/alcantara/alcantara_black_tangerine.png";
import alcantaraNavyBlueNavyBlue from "../assets/thumbnails/interior/alcantara/alcantara_navyBlue_navyBlue.png";
import alcantaraNavyBlueBlack from "../assets/thumbnails/interior/alcantara/alcantara_navyBlue_black.png";

// ---- FUNCTIONS ----
// Headlights
import headlightON from "../assets/thumbnails/functions/headlights/headlights_on.png";
import headlightOFF from "../assets/thumbnails/functions/headlights/headlights_off.png";

// Tail lights
import tailLightsON from "../assets/thumbnails/functions/tail_lights/tail_lights_on.png";
import tailLightsOFF from "../assets/thumbnails/functions/tail_lights/tail_lights_off.png";

// Front Lift System
import frontLiftON from "../assets/thumbnails/functions/front_lift/front_lift_on.png";
import frontLiftOFF from "../assets/thumbnails/functions/front_lift/front_lift_off.png";

// Windows
import windowsOpen from "../assets/thumbnails/functions/windows/windows_open.png";
import windowsClose from "../assets/thumbnails/functions/windows/windows_close.png";

// ---- CAMERAS ----
//Cameras Exterior
import cameraExt_3_4_front from "../assets/thumbnails/cameras/exterior/camera_34_front.png";
import cameraExtRear from "../assets/thumbnails/cameras/exterior/camera_rear.png";
import cameraExtSideView from "../assets/thumbnails/cameras/exterior/camera_side_view.png";
import cameraExt_3_4_rear from "../assets/thumbnails/cameras/exterior/camera_34_rear.png";
import cameraExtFront from "../assets/thumbnails/cameras/exterior/camera_front.png";
import cameraExt_3_4_UpperRear from "../assets/thumbnails/cameras/exterior/camera_34_upper_rear.png";
import cameraExt_3_4_UpperFront from "../assets/thumbnails/cameras/exterior/camera_34_upper_front.png";
import cameraExtUpperSideView from "../assets/thumbnails/cameras/exterior/camera_upper_side_view.png";

// Cameras Interior
import cameraIntDashboardDriver from "../assets/thumbnails/cameras/interior/dashboard_driver1.png";
import cameraIntDashboardCenter from "../assets/thumbnails/cameras/interior/dashboard_center1.png";
import cameraIntDashboardPassenger from "../assets/thumbnails/cameras/interior/dashboard_passenger1.png";
import cameraIntSeatsDriver from "../assets/thumbnails/cameras/interior/seats_driver1.png";
import cameraIntSeatsCenter from "../assets/thumbnails/cameras/interior/seats_center1.png";
import cameraIntSeatsPassenger from "../assets/thumbnails/cameras/interior/seats_passenger1.png";

// ---- MEDIA ----
//Weather
import sunnyWea from "../assets/thumbnails/weather/sunny.png";
import partlyCloudyWea from "../assets/thumbnails/weather/partly_cloudy.png";
import overcastWea from "../assets/thumbnails/weather/overcast.png";
import rainyWea from "../assets/thumbnails/weather/rainy.png";
import snowyWea from "../assets/thumbnails/weather/snowy.png";
import foggyWea from "../assets/thumbnails/weather/foggy.png";

//Environment
import mountainsEnv from "../assets/thumbnails/environment/mountains.png";
import racetrackEnv from "../assets/thumbnails/environment/racetrack.png";
import openStudioEnv from "../assets/thumbnails/environment/open_studio.png";

const list = [
  {
    name: "Exterior",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
      descriptor: {
        CaEx: "34fr",
      },
    },
    subActions: [
      {
        name: "Paint",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaEx: "34fr",
          },
        },
        subActions: [
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 1990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 390,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 390,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    ExPt: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Wheels",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Wh" },
        },
        subActions: [
          {
            name: "Model",
            muiIcon: "",
            subActions: [
              {
                name: "F50 GT Style",
                image: wheelTypeF50Style,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 3990,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "f50",
                  },
                  type: "select",
                },
              },
              {
                name: "GT3 Style",
                image: wheelTypeGT3Style,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 3150,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "gt3",
                  },
                  type: "select",
                },
              },
              {
                name: "S3 Style",
                image: wheelTypeS3Style,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 2790,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "s3",
                  },
                  type: "select",
                },
              },
              {
                name: "Rotiform KPR",
                image: wheelTypeRotiformKPR,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 3450,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "kpr",
                  },
                  type: "select",
                },
              },
              {
                name: "Rotiform NGO",
                image: wheelTypeRotiformNGO,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 2990,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "ngo",
                  },
                  type: "select",
                },
              },
              {
                name: "Rotiform NGO 2 Pieces",
                image: wheelTypeRotiformNGO2,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 3450,
                subActions: [],
                action: {
                  descriptor: {
                    WhMo: "ngo2",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Wheel Color",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Wh" },
        },
        subActions: [
          {
            name: "Color",
            muiIcon: "",
            subActions: [
              {
                name: "Hyper Silver",
                image: wheelColorHyperSilver,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "hs",
                  },
                  type: "select",
                },
              },
              {
                name: "White",
                image: wheelColorWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "wh",
                  },
                  type: "select",
                },
              },
              {
                name: "White Gold",
                image: wheelColorWhiteGold,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 110,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "wg",
                  },
                  type: "select",
                },
              },
              {
                name: "Black",
                image: wheelColorBlack,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "bl",
                  },
                  type: "select",
                },
              },
              {
                name: "Anthracite",
                image: wheelColorAnthracite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "an",
                  },
                  type: "select",
                },
              },
              {
                name: "Bronze",
                image: wheelColorBronze,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    WhCo: "br",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Brakes",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Wh" },
        },
        subActions: [
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    BrCo: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Tires",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Wh" },
        },
        subActions: [
          {
            name: "Model",
            muiIcon: "",
            subActions: [
              {
                name: "Toyo Proxes R888R",
                image: tireToyoProxes,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 1490,
                subActions: [],
                action: {
                  descriptor: {
                    TiMo: "to",
                  },
                  type: "select",
                },
              },
              {
                name: "Michelin Pilot Sport 4S",
                image: tireMichelinPS4S,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 1990,
                subActions: [],
                action: {
                  descriptor: {
                    TiMo: "mi",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Front Lip",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "FrLi" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    FrLi: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Fender Louvres",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "FeLo" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    FeLo: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Side Skirts",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "SiSk" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    SiSk: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Side Blades",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "SiBl" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    SiBl: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Mirror Caps",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "MiCa" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    MiCa: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Difusser",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "ReDi" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    ReDi: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Spoiler",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Sp" },
        },
        subActions: [
          {
            name: "Options",
            muiIcon: "",
            subActions: [
              {
                name: "With Spoiler",
                image: withSpoiler,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    SpAc: "on",
                  },
                  type: "select",
                },
              },
              {
                name: "Without Spoiler",
                image: withoutSpoiler,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 0.01,
                subActions: [],
                action: {
                  descriptor: {
                    SpAc: "off",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    SpCo: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Spoiler Plates",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Sp" },
        },
        subActions: [
          {
            name: "Exposed Carbon Fiber",
            muiIcon: "",
            subActions: [
              {
                name: "Woven Carbon Fiber",
                image: carbonFiber,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 295,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "wcf",
                  },
                  type: "select",
                },
              },
              {
                name: "Forged Carbon Fiber",
                image: forgedCarbon,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 350,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "fcf",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Metallic",
            muiIcon: "",
            subActions: [
              {
                name: "Progressive Red Metalic",
                image: progressiveRedMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "prm",
                  },
                  type: "select",
                },
              },
              {
                name: "Kemora Gray Metallic",
                image: kemoraGrayMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "kgm",
                  },
                  type: "select",
                },
              },
              {
                name: "Ascari Blue Metallic",
                image: ascariBlueMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "abm",
                  },
                  type: "select",
                },
              },
              {
                name: "Myth Black Metallic",
                image: mythBlackMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "mbm",
                  },
                  type: "select",
                },
              },
              {
                name: "Python Yellow Metallic",
                image: pythonYellowMetallic,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 150,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "pym",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Pearl Effect",
            muiIcon: "",
            subActions: [
              {
                name: "Daytona Gray Pearlescent",
                image: daytonaGrayPearlescent,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 250,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "dgp",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Solid",
            muiIcon: "",
            subActions: [
              {
                name: "Arkona White",
                image: arkonaWhite,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "aw",
                  },
                  type: "select",
                },
              },
              {
                name: "Kyalami Green",
                image: kyalamiGreen,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 90,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "kg",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Individual",
            muiIcon: "",
            subActions: [
              {
                name: "Individual Paint Finish",
                image: individualPaint,
                muiIcon: "",
                randomizable: false,
                customRGB: true,

                inSummary: true,
                price: 490,
                subActions: [],
                action: {
                  descriptor: {
                    SpPl: "ipf",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Exhaust",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Ex" },
        },
        subActions: [
          {
            name: "Tailpipes",
            muiIcon: "",
            subActions: [
              {
                name: "1 Tailpipe",
                image: exhaust1pipe,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 2990,
                subActions: [],
                action: {
                  descriptor: {
                    ExTp: "1",
                  },
                  type: "select",
                },
              },
              {
                name: "2 Tailpipes",
                image: exhaust2pipes,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 2490,
                subActions: [],
                action: {
                  descriptor: {
                    ExTp: "2",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Material",
            muiIcon: "",
            subActions: [
              {
                name: "Stainless steel ",
                image: stainlessSteelMaterial,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 1490,
                subActions: [],
                action: {
                  descriptor: {
                    ExMa: "ss",
                  },
                  type: "select",
                },
              },
              {
                name: "Titanium",
                image: titaniumMaterial,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 3490,
                subActions: [],
                action: {
                  descriptor: {
                    ExMa: "ti",
                  },
                  type: "select",
                },
              },
              {
                name: "Inconel",
                image: inconelMaterial,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4490,
                subActions: [],
                action: {
                  descriptor: {
                    ExMa: "in",
                  },
                  type: "select",
                },
              },
              {
                name: "Ceramic Coating",
                image: ceramicCoatingMaterial,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 1990,
                subActions: [],
                action: {
                  descriptor: {
                    ExMa: "cc",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Widebody Kit",
        image: "",
        muiIcon: "",
        baseOption: true,
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "",
            muiIcon: "",
            subActions: [
              {
                name: "",
                image: "",
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 17499.5,
                subActions: [],
                action: {
                  descriptor: {
                    widebody: true,
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Interior",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
      descriptor: {
        CaIn: "dd",
      },
    },
    subActions: [
      {
        name: "Leather",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Combinations",
            muiIcon: "",
            subActions: [
              {
                name: "Black / Black",
                image: leatherBlackBlack,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "leblbl",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Brown",
                image: leatherBlackBrown,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "leblbr",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Red",
                image: leatherBlackRed,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "leblre",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Tangerine",
                image: leatherBlackTangerine,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "leblta",
                  },
                  type: "select",
                },
              },
              {
                name: "Navy Blue / Navy Blue",
                image: leatherNavyBlueNavyBlue,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "lenbnb",
                  },
                  type: "select",
                },
              },
              {
                name: "Navy Blue / Black",
                image: leatherNavyBlueBlack,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 4990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "lenbbl",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Alcantara",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Combinations",
            muiIcon: "",
            subActions: [
              {
                name: "Black / Black",
                image: alcantaraBlackBlack,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alblbl",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Brown",
                image: alcantaraBlackBrown,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alblbr",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Red",
                image: alcantaraBlackRed,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alblre",
                  },
                  type: "select",
                },
              },
              {
                name: "Black / Tangerine",
                image: alcantaraBlackTangerine,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alblta",
                  },
                  type: "select",
                },
              },
              {
                name: "Navy Blue / Navy Blue",
                image: alcantaraNavyBlueNavyBlue,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alnbnb",
                  },
                  type: "select",
                },
              },
              {
                name: "Navy Blue / Black",
                image: alcantaraNavyBlueBlack,
                muiIcon: "",
                randomizable: true,
                customRGB: false,
                inSummary: true,
                price: 5990,
                subActions: [],
                action: {
                  descriptor: {
                    InCo: "alnbbl",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Functions",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
      descriptor: {
        CaEx: "34fr",
      },
    },
    subActions: [
      {
        name: "Headlights",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaEx: "fr",
          },
        },
        subActions: [
          {
            name: "Switch ON and OFF the headlights",
            muiIcon: "",
            subActions: [
              {
                name: "On",
                image: headlightON,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuHe: "on",
                  },
                  type: "select",
                },
              },
              {
                name: "Off",
                image: headlightOFF,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuHe: "off",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Tail Lights",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaEx: "re",
          },
        },
        subActions: [
          {
            name: "Switch ON and OFF the tail lights",
            muiIcon: "",
            subActions: [
              {
                name: "On",
                image: tailLightsON,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuTl: "on",
                  },
                  type: "select",
                },
              },
              {
                name: "Off",
                image: tailLightsOFF,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuTl: "off",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Windows",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "sv" },
        },
        subActions: [
          {
            name: "Operate the windows system",
            muiIcon: "",
            subActions: [
              {
                name: "Open",
                image: windowsOpen,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuWi: "dw",
                  },
                  type: "select",
                },
              },
              {
                name: "Close",
                image: windowsClose,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuWi: "up",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Front Lift System",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: { CaEx: "Wh" },
        },
        subActions: [
          {
            name: "Raise the ride height of the front axle",
            muiIcon: "",
            subActions: [
              {
                name: "On (Up)",
                image: frontLiftON,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuFl: "on",
                  },
                  type: "select",
                },
              },
              {
                name: "Off (Down)",
                image: frontLiftOFF,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    FuFl: "off",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Move wheels",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaEx: "34fr",
          },
        },
        subActions: [
          {
            name: "Rotate front wheels",
            muiIcon: "",
            subActions: [
              {
                name: "",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: 0,
                  max: 1,
                  step: 0.01,
                  defaultValue: 0.5,
                  valueLabelFormatter: (value) => {
                    const realValue = value * 60 - 30;
                    return `${realValue.toFixed(2)}°`;
                  },
                  marks: [
                    {
                      value: 0,
                      label: "-35°",
                    },
                    {
                      value: 0.5,
                      label: "0°",
                    },
                    {
                      value: 1,
                      label: "35°",
                    },
                  ],
                  descriptor: {
                    FuMw: "0deg",
                  },
                  type: "slider",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Cameras",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Exterior",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaEx: "34fr",
          },
        },
        subActions: [
          {
            name: "Move between the exterior cameras",
            muiIcon: "",
            subActions: [
              {
                name: "Front",
                image: cameraExtFront,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "fr",
                  },
                  type: "select",
                },
              },
              {
                name: "3/4 Front",
                image: cameraExt_3_4_front,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "34fr",
                  },
                  type: "select",
                },
              },
              {
                name: "Side View",
                image: cameraExtSideView,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "sv",
                  },
                  type: "select",
                },
              },
              {
                name: "3/4 Rear",
                image: cameraExt_3_4_rear,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "34re",
                  },
                  type: "select",
                },
              },
              {
                name: "Rear",
                image: cameraExtRear,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "re",
                  },
                  type: "select",
                },
              },
              {
                name: "3/4 Upper Rear",
                image: cameraExt_3_4_UpperRear,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "34ure",
                  },
                  type: "select",
                },
              },
              {
                name: "Upper Side View",
                image: cameraExtUpperSideView,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "usv",
                  },
                  type: "select",
                },
              },
              {
                name: "3/4 Upper Front",
                image: cameraExt_3_4_UpperFront,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaEx: "34ufr",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Interior",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
          descriptor: {
            CaIn: "dd",
          },
        },
        subActions: [
          {
            name: "Move between the interior cameras",
            muiIcon: "",
            subActions: [
              {
                name: "Dashboard Center",
                image: cameraIntDashboardCenter,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "dc",
                  },
                  type: "select",
                },
              },
              {
                name: "Dashboard Driver ",
                image: cameraIntDashboardDriver,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "dd",
                  },
                  type: "select",
                },
              },
              {
                name: "Dashboard Passenger",
                image: cameraIntDashboardPassenger,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "dp",
                  },
                  type: "select",
                },
              },
              {
                name: "Seats Center",
                image: cameraIntSeatsCenter,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "sc",
                  },
                  type: "select",
                },
              },
              {
                name: "Seats Driver",
                image: cameraIntSeatsDriver,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "sd",
                  },
                  type: "select",
                },
              },
              {
                name: "Seats Passenger",
                image: cameraIntSeatsPassenger,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    CaIn: "sp",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Media",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Environment",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Time of the Day",
            muiIcon: "",
            subActions: [
              {
                name: "Auto",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: 0,
                  max: 12,
                  step: 0.5,
                  defaultValue: 8,
                  valueLabelFormatter: (value) => {
                    const hoursFromStart = Math.floor(value);
                    const minutesFromStart = (value % 1) * 60;
                    const hours = 6 + hoursFromStart;
                    const minutes = minutesFromStart;
                    const formattedHours = String(hours).padStart(2, "0");
                    const formattedMinutes = String(minutes).padStart(2, "0");
                    return `${formattedHours}:${formattedMinutes}`;
                  },

                  marks: [
                    {
                      value: 0,
                      label: "06:00",
                    },
                    {
                      value: 3,
                      label: "9:00",
                    },
                    {
                      value: 6,
                      label: "12:00",
                    },
                    {
                      value: 9,
                      label: "15:00",
                    },
                    {
                      value: 12,
                      label: "18:00",
                    },
                  ],
                  descriptor: {
                    MeTd: "on",
                  },
                  type: "slider",
                },
              },
            ],
          },
          {
            name: "Weather",
            muiIcon: "",
            subActions: [
              {
                name: "Sunny",
                image: sunnyWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "su",
                  },
                  type: "select",
                },
              },
              {
                name: "Partly Cloudy",
                image: partlyCloudyWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "pc",
                  },
                  type: "select",
                },
              },
              {
                name: "Overcast",
                image: overcastWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "oc",
                  },
                  type: "select",
                },
              },
              {
                name: "Rainy",
                image: rainyWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "ra",
                  },
                  type: "select",
                },
              },
              {
                name: "Snowy",
                image: snowyWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "sn",
                  },
                  type: "select",
                },
              },
              {
                name: "Foggy",
                image: foggyWea,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeWe: "fo",
                  },
                  type: "select",
                },
              },
            ],
          },
          {
            name: "Environment",
            muiIcon: "",
            subActions: [
              {
                name: "Mountains",
                image: mountainsEnv,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeBg: "mo",
                  },
                  type: "select",
                },
              },
              {
                name: "Race Track",
                image: racetrackEnv,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeBg: "rt",
                  },
                  type: "select",
                },
              },
              {
                name: "Open Studio",
                image: openStudioEnv,
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  descriptor: {
                    MeBg: "st",
                  },
                  type: "select",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Camera Settings",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Focal Length",
            muiIcon: "",
            subActions: [
              {
                name: "mm",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: 18,
                  max: 100,
                  step: 1,
                  defaultValue: 55,
                  valueLabelFormatter: (value) => {
                    return `${value} mm`;
                  },
                  marks: [
                    {
                      value: 24,
                      label: "24mm",
                    },
                    {
                      value: 55,
                      label: "55mm",
                    },
                    {
                      value: 80,
                      label: "80mm",
                    },
                    {
                      value: 100,
                      label: "100mm",
                    },
                  ],
                  descriptor: {
                    MeCFL: "50mm",
                  },
                  type: "slider",
                },
              },
            ],
          },
          {
            name: "Aperture",
            muiIcon: "",
            subActions: [
              {
                name: "steps",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: 1.2,
                  max: 22,
                  step: 0.2,
                  defaultValue: 6,
                  valueLabelFormatter: (value) => {
                    return `f/${value}`;
                  },
                  marks: [
                    {
                      value: 1.4,
                      label: "f/1.4",
                    },
                    {
                      value: 5.6,
                      label: "f/5.6",
                    },
                    {
                      value: 8,
                      label: "f/8",
                    },
                    {
                      value: 16,
                      label: "f/16",
                    },
                    {
                      value: 22,
                      label: "f/22",
                    },
                  ],
                  descriptor: {
                    MeCAp: "f/2.8",
                  },
                  type: "slider",
                },
              },
            ],
          },
          {
            name: "Exposure",
            muiIcon: "",
            subActions: [
              {
                name: "",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: -2,
                  max: 2,
                  step: 0.1,
                  defaultValue: 1,
                  marks: [
                    {
                      value: -2,
                      label: "-2",
                    },
                    {
                      value: -1,
                      label: "-1",
                    },
                    {
                      value: 0,
                      label: "0",
                    },
                    {
                      value: 1,
                      label: "+1",
                    },
                    {
                      value: 2,
                      label: "+2",
                    },
                  ],
                  descriptor: {
                    MeCEx: "0.0",
                  },
                  type: "slider",
                },
              },
            ],
          },
          {
            name: "Contrast",
            muiIcon: "",
            subActions: [
              {
                name: "",
                image: "",
                muiIcon: "",
                randomizable: false,
                customRGB: false,
                inSummary: false,
                price: 0,
                subActions: [],
                action: {
                  min: 0.5,
                  max: 2,
                  step: 0.1,
                  defaultValue: 1,
                  marks: [
                    {
                      value: 0.5,
                      label: "0.5",
                    },
                    {
                      value: 1,
                      label: "1",
                    },
                    {
                      value: 1.5,
                      label: "1.5",
                    },
                    {
                      value: 2,
                      label: "2",
                    },
                  ],
                  descriptor: {
                    MeCCo: "10",
                  },
                  type: "slider",
                },
              },
            ],
          },
        ],
      },
      {
        name: "Export Image",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [],
      },
    ],
  },
];

export default list;
